import Vue from 'vue/dist/vue.esm'

Vue.directive('normalize', {
    inserted(el) {
        el.addEventListener('blur', () => {
            let value = el.value;
            if (value) {
                el.value = value.replace(/\s+/g, ' ').trim()
                el.dispatchEvent(new Event('input')); // Trigger input event to update v-model
            }
        });
    }
});
